import { Identifier } from "../../core";
export class ProductTypeGroupId extends Identifier {
    constructor(id) {
        super("ProductTypeGroupId", id);
    }
}
